import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui";

/** A provider redirect is navigation, not evidence that payment was confirmed. */
export default function BillingReturn({
  cancelled = false,
}: {
  cancelled?: boolean;
}) {
  const { t } = useTranslation("ui");
  return (
    <section className="vl-public-content">
      <span className="vl-eyebrow">Valid Labels</span>
      <h1>{t(cancelled ? "billingCancelledTitle" : "billingReturnTitle")}</h1>
      <p>{t(cancelled ? "billingCancelledText" : "billingReturnText")}</p>
      <Button asChild>
        <Link to="/settings?section=billing">{t("openBilling")}</Link>
      </Button>
    </section>
  );
}
